// extracted by mini-css-extract-plugin
export default {"container":"external_link-module__container--2s5Yp","icon":"external_link-module__icon--2lovn","link":"external_link-module__link--2Vlsk"};